.DiceboundModal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(34, 34, 34, 0.5);
}
.DiceboundModal .Header,
.DiceboundModal .Footer {
  font-size: 0.5em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  margin-top: 2em;
  margin-bottom: 2em;
}
.DiceboundModal .Header .BigText,
.DiceboundModal .Footer .BigText {
  font-size: 1.3em;
  line-height: 1em;
}
.DiceboundModal .Header .SmallText,
.DiceboundModal .Footer .SmallText {
  font-size: 0.75em;
  line-height: 1em;
}
.DiceboundModal .Header .SmallText[isHoverable]:hover,
.DiceboundModal .Footer .SmallText[isHoverable]:hover {
  color: hotpink;
}
.DiceboundModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.DiceboundModal .UnitsSection .Or {
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit {
  font-size: 0.75em;
  margin: 0em 0.2em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition-duration: 0.25s;
  transition-property: opacity, filter, transform;
}
.DiceboundModal .UnitsSection .Unit .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
  margin-top: 0.4em;
}
.DiceboundModal .UnitsSection .Unit .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.DiceboundModal .UnitsSection .Unit .DraftButton {
  margin-top: 1.4em;
  width: 8em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--editor-font);
}
.DiceboundModal .UnitsSection .Unit .DraftButton span {
  font-size: 1rem;
  line-height: 1rem;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Number {
  font-size: 0.25em;
  text-align: center;
  margin-bottom: 0.25em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Description,
.DiceboundModal .UnitsSection .Unit .DraftableDice .Name {
  font-size: 0.5em;
  text-align: center;
  margin-bottom: 0.5em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
  height: 1em;
  line-height: 1em;
  position: relative;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Description span,
.DiceboundModal .UnitsSection .Unit .DraftableDice .Name span {
  left: -3em;
  right: -3em;
  position: absolute;
  text-align: center;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .DiceLayout {
  background-color: transparent;
  border: none;
  font-size: 1em;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace {
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
}
.DiceboundModal .UnitsSection .Unit .EquippedDice {
  font-size: 0.5em;
}
.DiceboundModal .UnitsSection .Unit .EquippableDice {
  margin-top: 0.2em;
}
.DiceboundModal .UnitsSection .Unit .EquippableDice .Description {
  font-size: 0.25em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit .Status {
  left: 0em;
  right: 0em;
  bottom: -1.4em;
  position: absolute;
  line-height: 1em;
  text-align: center;
  font-size: 0.3em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] {
  filter: grayscale(2);
  opacity: 0.75;
  transform: translateY(-0.5em);
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] .Label {
  display: none;
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] .Status {
  opacity: 1;
}
.DiceboundModal .DoneSection {
  padding-top: 0.5em;
  text-align: center;
}
.DiceboundModal .DoneSection button {
  font: inherit;
  font-size: 0.5em;
  padding: 0em 1em;
}
.DiceboundModal .DoneSection button:not([isEnabled]) {
  opacity: 0.5;
}
.DiceboundModal .DoneSection button:not(:last-child) {
  margin-right: 0.5em;
}
.DiceboundModal .LootablePassiveSection {
  width: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.DiceboundModal .LootablePassiveSection .LootablePassive {
  width: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Unit {
  top: 0em;
  width: 1em;
  right: 0.2em;
  bottom: 0em;
  position: absolute;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Unit .UnitSprite {
  top: 0em;
  bottom: 0em;
  margin: auto;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary {
  font-size: 0.5em;
  padding: 0.618em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary .Title {
  font-size: 1em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary .Description {
  font-size: 0.5em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive:not(:last-child) {
  margin-bottom: 0.2em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}
.LearnToRightClickModal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(34, 34, 34, 0.5);
  animation-name: fade-in;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}
.LearnToRightClickModal .Header,
.LearnToRightClickModal .Footer {
  font-size: 0.5em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  margin-top: 2em;
  margin-bottom: 2em;
}
.LearnToRightClickModal .Header .BigText,
.LearnToRightClickModal .Footer .BigText {
  font-size: 1.3em;
  line-height: 1em;
}
.LearnToRightClickModal .Header .SmallText,
.LearnToRightClickModal .Footer .SmallText {
  font-size: 0.75em;
  line-height: 1em;
}
.LearnToRightClickModal .Header .SmallText[isHoverable]:hover,
.LearnToRightClickModal .Footer .SmallText[isHoverable]:hover {
  color: hotpink;
}
.LearnToRightClickModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.LearnToRightClickModal .UnitsSection .Or {
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.LearnToRightClickModal .UnitsSection .Unit {
  font-size: 0.75em;
  margin: 0em 0.2em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition-duration: 0.25s;
  transition-property: opacity, filter, transform;
}
.LearnToRightClickModal .UnitsSection .Unit .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
  margin-top: 0.4em;
}
.LearnToRightClickModal .UnitsSection .Unit .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.LearnToRightClickModal .UnitsSection .Unit .DraftButton {
  margin-top: 1.4em;
  width: 8em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--editor-font);
}
.LearnToRightClickModal .UnitsSection .Unit .DraftButton span {
  font-size: 1rem;
  line-height: 1rem;
}
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .Number {
  font-size: 0.25em;
  text-align: center;
  margin-bottom: 0.25em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .Description,
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .Name {
  font-size: 0.5em;
  text-align: center;
  margin-bottom: 0.5em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
  height: 1em;
  line-height: 1em;
  position: relative;
}
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .Description span,
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .Name span {
  left: -3em;
  right: -3em;
  position: absolute;
  text-align: center;
}
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .DiceLayout {
  background-color: transparent;
  border: none;
  font-size: 1em;
}
.LearnToRightClickModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace {
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
}
.LearnToRightClickModal .UnitsSection .Unit .EquippedDice {
  font-size: 0.5em;
}
.LearnToRightClickModal .UnitsSection .Unit .EquippableDice {
  margin-top: 0.2em;
}
.LearnToRightClickModal .UnitsSection .Unit .EquippableDice .Description {
  font-size: 0.25em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.LearnToRightClickModal .UnitsSection .Unit .Status {
  left: 0em;
  right: 0em;
  bottom: -1.4em;
  position: absolute;
  line-height: 1em;
  text-align: center;
  font-size: 0.3em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.LearnToRightClickModal .UnitsSection .Unit[isLockedIn] {
  filter: grayscale(2);
  opacity: 0.75;
  transform: translateY(-0.5em);
}
.LearnToRightClickModal .UnitsSection .Unit[isLockedIn] .Label {
  display: none;
}
.LearnToRightClickModal .UnitsSection .Unit[isLockedIn] .Status {
  opacity: 1;
}
.LearnToRightClickModal .DoneSection {
  padding-top: 0.5em;
  text-align: center;
}
.LearnToRightClickModal .DoneSection button {
  font: inherit;
  font-size: 0.5em;
  padding: 0em 1em;
}
.LearnToRightClickModal .DoneSection button:not([isEnabled]) {
  opacity: 0.5;
}
.LearnToRightClickModal .DoneSection button:not(:last-child) {
  margin-right: 0.5em;
}
.LearnToRightClickModal .LootablePassiveSection {
  width: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.LearnToRightClickModal .LootablePassiveSection .LootablePassive {
  width: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
}
.LearnToRightClickModal .LootablePassiveSection .LootablePassive .Unit {
  top: 0em;
  width: 1em;
  right: 0.2em;
  bottom: 0em;
  position: absolute;
}
.LearnToRightClickModal .LootablePassiveSection .LootablePassive .Unit .UnitSprite {
  top: 0em;
  bottom: 0em;
  margin: auto;
}
.LearnToRightClickModal .LootablePassiveSection .LootablePassive .Summary {
  font-size: 0.5em;
  padding: 0.618em;
}
.LearnToRightClickModal .LootablePassiveSection .LootablePassive .Summary .Title {
  font-size: 1em;
}
.LearnToRightClickModal .LootablePassiveSection .LootablePassive .Summary .Description {
  font-size: 0.5em;
}
.LearnToRightClickModal .LootablePassiveSection .LootablePassive:not(:last-child) {
  margin-bottom: 0.2em;
}
.LearnToRightClickModal .LootablePassiveSection .LootablePassive:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}
.LearnToRightClickModal .UnitsSection {
  opacity: 0;
  animation-delay: 1s;
  animation-name: fade-in;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  position: relative;
  z-index: 10000;
}
.LearnToRightClickModal .Fill {
  top: 0em;
  left: 0em;
  right: 0em;
  bottom: 0em;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: black;
  background: radial-gradient(circle 2em at center, transparent 1.9em, rgba(0, 0, 0, 0.8) 2em);
  transform: scale(10);
  animation-name: zoom-in;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 1s;
  animation-delay: 1s;
}
.LearnToRightClickModal.LearnToRightClickModal .Fill {
  background: radial-gradient(circle 1.5em at center, transparent 1.4em, rgba(0, 0, 0, 0.8) 1.5em);
}
.LearnToRightClickModal .Content {
  position: relative;
  z-index: 10;
}
.LearnToRightClickModal .Content .Header {
  opacity: 0;
  animation-name: fade-in;
  animation-duration: 2s;
  animation-delay: 3s;
  animation-fill-mode: forwards;
  position: absolute;
  top: -4em;
  left: -8em;
  right: -8em;
  width: 10em;
  margin: auto;
}
.LearnToRightClickModal .Content .Footer {
  opacity: 0;
  animation-name: fade-in;
  animation-duration: 2s;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  position: absolute;
  bottom: -2em;
  left: -8em;
  right: -8em;
  width: 10em;
  margin: auto;
  display: none;
}
.LearnToRightClickModal .Content .Footer[isVisible] {
  display: block;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes zoom-in {
  0% {
    transform: scale(10);
  }
  100% {
    transform: scale(1);
  }
}
